export default __webpack_public_path__ + "static/media/celestial-bg.0b012ccc.png";